<template>
  <div class="addedit-role">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">
          {{
            editRoute ? $t("labels.edituser_role") : $t("labels.adduser_role")
          }}
        </h2>
      </div>
    </div>
    <form @submit.prevent="checkValidation()" autocomplete="off">
      <vx-card class="addedit-role-card">
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 md:mr-2 mb-4 p-0">
            <label>{{ $t("labels.role_name") }}</label>
            <vs-input
              v-validate="'required'"
              type="text"
              class="w-full mt-1"
              name="role_validation"
              v-model="name"
              icon-no-border
              :disabled="is_system_defined"
            />
            <span class="text-danger text-sm">{{
              errors.first("role_validation")
            }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 ml-0 p-0">
            <label>{{ $t("labels.role_description") }}</label>
            <vs-textarea
              v-validate="'required'"
              name="role_description"
              v-model="description"
              class="mb-0 mt-1"
            />
            <span class="text-danger text-sm">{{
              errors.first("role_description")
            }}</span>
          </div>
        </div>
        <div class="vx-row mt-8">
          <div class="vx-col w-full">
            <h3>{{ $t("labels.permissions") }}</h3>
          </div>
          <div class="vx-col sm: w-full md:w-full">
            <vs-table :data="modules" class="permission">
              <template slot="thead">
                <vs-th class="col-md-2">{{ $t("labels.name") }}</vs-th>
                <vs-th class="role-th col-md-2">{{ $t("labels.all") }}</vs-th>
                <vs-th class="role-th col-md-2">{{ $t("labels.view") }}</vs-th>
                <vs-th class="role-th col-md-2">{{ $t("labels.add") }}</vs-th>
                <vs-th class="role-th col-md-2">{{
                  $t("labels.modify")
                }}</vs-th>
                <vs-th class="role-th col-md-2">{{
                  $t("labels.delete")
                }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                  :class="{
                    'bg-grey-light header_permission':
                      tr.sub_modules.length > 0,
                  }"
                >
                  <vs-th class="pl-4"
                    >{{ tr.parent ? tr.parent.name + " - " : ""
                    }}{{ tr.name }}</vs-th
                  >
                  <vs-td>
                    <vs-checkbox
                      v-model="tr.permissions.all"
                      @change.native="updateAccess($event, indextr)"
                      v-if="tr.sub_modules.length == 0"
                    ></vs-checkbox>
                  </vs-td>
                  <vs-td>
                    <vs-checkbox
                      @change.native="checkAccess(indextr)"
                      v-model="tr.permissions.view"
                      v-if="tr.sub_modules.length == 0"
                    ></vs-checkbox>
                  </vs-td>
                  <vs-td>
                    <vs-checkbox
                      @change.native="checkAccess(indextr)"
                      v-model="tr.permissions.add"
                      v-if="tr.sub_modules.length == 0"
                    ></vs-checkbox>
                  </vs-td>
                  <vs-td>
                    <vs-checkbox
                      @change.native="checkAccess(indextr)"
                      v-model="tr.permissions.modify"
                      v-if="tr.sub_modules.length == 0"
                    ></vs-checkbox>
                  </vs-td>
                  <vs-td>
                    <vs-checkbox
                      @change.native="checkAccess(indextr)"
                      v-model="tr.permissions.delete"
                      v-if="tr.sub_modules.length == 0"
                    ></vs-checkbox>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <div class="mt-8 flex justify-center">
          <vs-button
            type="filled"
            color="primary"
            id="role-add-edit"
            button="submit"
            class="login-btn"
            >{{
              editRoute ? $t("labels.edit_role") : $t("labels.add_role")
            }}</vs-button
          >
        </div>
      </vx-card>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      description: "",
      name: "",
      is_system_defined: false,
      modules: [],
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.setValidationMessage();
    this.getModules();
  },
  methods: {
    updateAccess($event, index) {
      if (!this.modules.length) return;
      let result = $event.target.value === "true";
      var permissions = this.modules[index].permissions;

      permissions.add = result;
      permissions.modify = result;
      permissions.delete = result;
      permissions.view = result;
    },
    checkAccess(index) {
      if (!this.modules.length) return;
      var permissions = this.modules[index].permissions;
      if (
        permissions.add &&
        permissions.modify &&
        permissions.delete &&
        permissions.view
      ) {
        permissions.all = true;
      } else {
        permissions.all = false;
      }
    },
    checkValidation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addEditRole();
        }
      });
    },

    //Calling API for Modules
    async getModules() {
      let response = await this.getHTTPGetResponse("/modules");
      if (response) {
        let data = response.data;
        let modules = data.modules;
        modules.map(function (mod) {
          // default premission for module having submodules is true
          var default_permission = mod.sub_modules.length > 0;
          mod.permissions = {
            view: default_permission,
            add: default_permission,
            modify: default_permission,
            delete: default_permission,
            all: default_permission,
          };
          return mod;
        });
        this.modules = modules;
        //check for edit route
        if (this.editRoute) {
          this.getRoleDetail();
        }
      }
    },

    //Add/Update role
    async addEditRole() {
      let permissions = [];
      let modules = this.modules;
      for (var i = 0; i < modules.length; i++) {
        var mod = modules[i];
        let obj = {
          module_id: mod.id,
          permissions: {
            add: mod.permissions.add,
            modify: mod.permissions.modify,
            delete: mod.permissions.delete,
            view: mod.permissions.view,
          },
        };
        permissions.push(obj);
      }
      let input = {
        name: this.name,
        description: this.description,
        modules: permissions,
      };
      let url = this.editRoute ? "/role/update/" + this.editRoute : "/role/add";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#role-add-edit",
        true
      );
      if (response) {
        this.$router.push({ name: "Roles" });
      }
    },

    //Get role detail
    async getRoleDetail() {
      let response = await this.getHTTPGetResponse(
        "/role/get/" + this.editRoute
      );
      if (response) {
        let role = response.data.role;
        this.name = role.name;
        this.is_system_defined = role.is_system_defined;
        this.description = role.description;
        let modules = role.modules;
        for (var i = 0; i < modules.length; i++) {
          var mod = modules[i];
          if (!mod.permissions || !mod.permissions.data) continue;
          let id = mod.id;
          let index = this.modules.findIndex((mod) => mod.id === id);
          let permission = mod.permissions.data;
          let all =
            permission.add &&
            permission.view &&
            permission.modify &&
            permission.delete
              ? true
              : false;
          this.modules[index].permissions = {
            add: permission.add,
            modify: permission.modify,
            delete: permission.delete,
            view: permission.view,
            all: all,
          };
        }
      }
    },
    goBack() {
      history.back();
    },
  },
};
</script>
<style scoped>
h3 {
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 15px;
}
.has-sub-modules th,
.has-sub-modules td {
  text-decoration: underline;
}
th.role-th {
  text-align: center !important;
}
</style>
